var _rect, _g, _text, _circle, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpeedMeter = function SvgSpeedMeter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_85_2",
    "data-name": "Component 85 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 70,
    viewBox: "0 0 120 70",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 120,
    height: 70,
    rx: 5,
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(-778 -164.031)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_0.271",
    "data-name": 0.271,
    transform: "translate(838 211)",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.565,
    y: 0
  }, "0.271")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Average_kWh_mile",
    "data-name": "Average kWh/mile",
    transform: "translate(24 58.25)",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Average kWh/mile"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(95 19)",
    fill: "#f99619"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(-2441 -1770.751)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2451 1827.751)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 2451.934, 1819.084)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2454.357 1810.71) rotate(20)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2458.199 1802.885) rotate(30)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732",
    "data-name": "Rectangle 732",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2463.341 1795.846) rotate(40)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2469.627 1789.806) rotate(50)",
    fill: "#5ea851"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2476.866 1784.95) rotate(60)",
    fill: "#56a85e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2484.839 1781.424) rotate(70)",
    fill: "#4da870"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(0.174, 0.985, -0.985, 0.174, 2493.303, 1779.337)",
    fill: "#46a87c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_737",
    "data-name": "Rectangle 737",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2502 1778.751) rotate(90)",
    fill: "#39a893"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_738",
    "data-name": "Rectangle 738",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(-0.174, 0.985, -0.985, -0.174, 2510.667, 1779.684)",
    fill: "#54ab87"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_739",
    "data-name": "Rectangle 739",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2519.041 1782.108) rotate(110)",
    fill: "#a6b354"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_740",
    "data-name": "Rectangle 740",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2526.866 1785.95) rotate(120)",
    fill: "#bfb544"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_741",
    "data-name": "Rectangle 741",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2533.905 1791.092) rotate(130)",
    fill: "#fcbb1d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_742",
    "data-name": "Rectangle 742",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2539.945 1797.378) rotate(140)",
    fill: "#f99019"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2544.801 1804.617) rotate(150)",
    fill: "#f45d14"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2548.327 1812.59) rotate(160)",
    fill: "#ef2e0f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_745",
    "data-name": "Rectangle 745",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(-0.985, 0.174, -0.174, -0.985, 2550.414, 1821.053)",
    fill: "#eb0c0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728-2",
    "data-name": "Rectangle 728",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 2451.277, 1823.397)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729-2",
    "data-name": "Rectangle 729",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 2452.963, 1814.844)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730-2",
    "data-name": "Rectangle 730",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2456.107 1806.714) rotate(25)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731-2",
    "data-name": "Rectangle 731",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 2460.616, 1799.253)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732-2",
    "data-name": "Rectangle 732",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2466.352 1792.689) rotate(45)",
    fill: "#61a84a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733-2",
    "data-name": "Rectangle 733",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(0.574, 0.819, -0.819, 0.574, 2473.141, 1787.22)",
    fill: "#5ba858"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734-2",
    "data-name": "Rectangle 734",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2480.775 1783.013) rotate(65)",
    fill: "#52a868"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_735-2",
    "data-name": "Rectangle 735",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 2489.025, 1780.196)",
    fill: "#48a877"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_736-2",
    "data-name": "Rectangle 736",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2497.639 1778.854) rotate(85)",
    fill: "#3fa88b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_737-2",
    "data-name": "Rectangle 737",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(-0.087, 0.996, -0.996, -0.087, 2506.354, 1779.028)",
    fill: "#3ca997"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_738-2",
    "data-name": "Rectangle 738",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 2514.907, 1780.713)",
    fill: "#71ad74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_739-2",
    "data-name": "Rectangle 739",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2523.037 1783.858) rotate(115)",
    fill: "#c3b642"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_740-2",
    "data-name": "Rectangle 740",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(-0.574, 0.819, -0.819, -0.574, 2530.498, 1788.367)",
    fill: "#e3b92e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_741-2",
    "data-name": "Rectangle 741",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2537.062 1794.103) rotate(135)",
    fill: "#f99619"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_742-2",
    "data-name": "Rectangle 742",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(-0.819, 0.574, -0.574, -0.819, 2542.531, 1800.892)",
    fill: "#f35c13"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743-2",
    "data-name": "Rectangle 743",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2546.738 1808.527) rotate(155)",
    fill: "#f14312"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_744-2",
    "data-name": "Rectangle 744",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 2549.555, 1816.776)",
    fill: "#eb0c0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_745-2",
    "data-name": "Rectangle 745",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2550.896 1825.389) rotate(175)",
    fill: "#eb0c0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_747",
    "data-name": "Rectangle 747",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2541 1827.751)",
    fill: "#eb0c0c"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpeedMeter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/speed_meter.97ce5c5a30cb6350c4dae3a1b1be816c.svg";